import { SEPARATOR_PING_DATA } from "../config/config";

// Format time in minutes and seconds
export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${minutes}:${secs}`;
};

export const timers = {
  encode: (pingNumber, whiteTime, blackTime) => btoa(btoa(
      `${pingNumber}${SEPARATOR_PING_DATA}${whiteTime}${SEPARATOR_PING_DATA}${blackTime}`)
    ).replace(/=/g, ''),
  decode: (checksum) => atob(atob(checksum)),
};

export const formatTimestampToUTC = ({ ts }) => {
  const date = new Date(ts);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${year}:${month}:${day}-${hours}:${minutes}`;
};
